import { Box } from 'foundations-components/transitional/components/Box';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { useContext } from 'react';
import { SelectedReports } from 'reporting-action-components/reportingActions/exportReport/ExportReportButton';
import { getDataType, getDimensions } from 'reporting-data/report/configReportGetters';
import CheckboxTableDimensionSelector from 'reporting-enablement/components/singleReportViewer/common/checkbox-table/CheckboxTableDimensionSelector';
import { EnablementTrackingContext } from '../../../monitoring/EnablementTrackingContext';
import { SingleObjectTableMetricsEditor } from '../../reportEditors/TableMetricEditor/SingleObjectTableMetricEditor';
import { getEditorSchemasFromConfig } from '../../reportEditors/common/editorUtils';
import { useEditorComponents } from '../../reportEditors/common/useEditorComponents';
import { SRVTableActionsMenu } from '../common/srv-table/SRVTableActionsMenu';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SRVCheckboxTableReportCardActions = ({
  previewReport,
  onPreviewReportChange,
  checkboxTableReport,
  setSelectedDimension,
  selectedDimension,
  is2DSupported,
  suppressActionsBar = false
}) => {
  const {
    appUsageTracker
  } = useContext(EnablementTrackingContext);
  const reportDimensions = getDimensions(previewReport);
  const reportDataType = getDataType(previewReport);
  const editors = useEditorComponents(previewReport, getEditorSchemasFromConfig(previewReport), [SingleObjectTableMetricsEditor]);
  return /*#__PURE__*/_jsxs(TFlex, {
    direction: "row",
    justify: "between",
    children: [/*#__PURE__*/_jsx(Box, {
      shrink: 0,
      children: !is2DSupported && /*#__PURE__*/_jsx(CheckboxTableDimensionSelector, {
        selectedDimension: selectedDimension,
        setSelectedDimension: setSelectedDimension,
        reportDimensions: reportDimensions,
        reportDataType: reportDataType
      })
    }), !suppressActionsBar && /*#__PURE__*/_jsxs(Flex, {
      alignItems: "center",
      padding: "200",
      children: [editors.map(Editor => /*#__PURE__*/_jsx(Editor, {
        appUsageTracker: appUsageTracker,
        isV2FilterExperience: true,
        onChange: onPreviewReportChange,
        options: {
          readOnly: false
        },
        report: previewReport
      }, Editor.displayName || Editor.name)), /*#__PURE__*/_jsx(SRVTableActionsMenu, {
        report: checkboxTableReport,
        selectedReport: SelectedReports.summarizedTable
      })]
    })]
  });
};
export default SRVCheckboxTableReportCardActions;